
export function upgrade(userSettings) {

  const {myColors} = userSettings

  if (!myColors) {
    return userSettings
  }

  delete userSettings.myColors

  userSettings.favorites.colors = myColors
}

export const DEFAULT_SETTINGS = {
  welcomeBannerSeen: false,
  isLiked: false,
  isQuickMenuShown: false,
  tips: {
    version: 0
  },
  favorites: {
    fonts: [],
    colors: []
  },
  preferences: {
    autoConfirmSwapVideo: false
  }
}